import NewsletterSection from '@/components/NewsletterSection'
import BlogCard from '@/components/BlogCard'
import { getBiography, getLatestBlogs, getSocials } from '@/lib/api'
import BlueHero from '@/components/BlueHero'

export default async function AboutBio() {
  const [bio, blogs, socials] = await Promise.all([
    getBiography(),
    getLatestBlogs(),
    getSocials(),
  ])

  const stats = bio?.stats || { years_experience: 25, people_worked_with: 1000, projects: 60 }
  const latestBlogs = blogs?.slice(0, 3) || []
  const socialLinks = socials || []


  return (
    <>
      <BlueHero title="MR. ALRIFAI BIO" />

      {/* ABOUT GHASSAN */}
      <section style={{ background: '#07090e', padding: '64px 0' }}>
        <div style={{ maxWidth: '1000px', margin: '0 auto', padding: '0 40px' }}>
          <h2 style={{ fontSize: '20px', fontWeight: 900, color: '#fff', textAlign: 'center', letterSpacing: '0.10em', marginBottom: '40px' }}>ABOUT GHASSAN .</h2>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '48px', alignItems: 'center' }}>
            {/* Video placeholder — uses video_url from API if available */}
            <div style={{ position: 'relative', background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.10)', borderRadius: '8px', aspectRatio: '4/3', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', overflow: 'hidden' }}>
              {bio?.video_url ? (
                <iframe src={bio.video_url.replace('watch?v=', 'embed/')} className="w-full h-full" style={{ border: 'none' }} allowFullScreen />
              ) : (
                <div style={{ width: '52px', height: '52px', borderRadius: '50%', background: 'rgba(249,115,22,0.9)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="white"><polygon points="5,3 19,12 5,21"/></svg>
                </div>
              )}
            </div>
            {/* Text from API */}
            <div>
              <p style={{ fontSize: '14px', color: 'rgba(255,255,255,0.72)', lineHeight: 1.9 }}>
                {bio?.about_sliders?.[0]?.description || 'Ghassan Alfifai Is An Experienced Entrepreneur In Business Development And Strategic Planning, Focusing On Collaboration, Growth, And Innovation. He Excels At Turning Challenges Into Opportunities And Aims To Build Strong Partnerships And Support Startups For A Better Future.'}
              </p>
            </div>
          </div>

          {/* Stats */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '32px', marginTop: '52px', paddingTop: '40px', borderTop: '1px solid rgba(255,255,255,0.06)', textAlign: 'center' }}>
            {[
              { icon: <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#f97316" strokeWidth="1.5"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>, val: `+${stats.years_experience}`, label: 'YEARS EXPERIENCE' },
              { icon: <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#f97316" strokeWidth="1.5"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><line x1="23" y1="11" x2="17" y2="11"/><line x1="20" y1="8" x2="20" y2="14"/></svg>, val: `+${stats.people_worked_with}`, label: 'PEOPLE I WORK WITH' },
              { icon: <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#f97316" strokeWidth="1.5"><circle cx="12" cy="12" r="10"/><polyline points="12,6 12,12 16,14"/></svg>, val: `+${stats.projects}`, label: 'ALL PROJECTS' },
            ].map((s, i) => (
              <div key={i}>
                <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '8px' }}>{s.icon}</div>
                <div style={{ fontSize: '26px', fontWeight: 900, color: '#fff', marginBottom: '4px' }}>{s.val}</div>
                <div style={{ fontSize: '10px', color: 'rgba(255,255,255,0.45)', letterSpacing: '0.12em' }}>{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* PROFESSIONAL CAREER — from API about_sliders */}
      <section style={{ background: '#0c0f1c', padding: '60px 0' }}>
        <div style={{ maxWidth: '900px', margin: '0 auto', padding: '0 40px' }}>
          <h3 style={{ fontSize: '16px', fontWeight: 800, color: '#f97316', marginBottom: '20px' }}>
            Professional Career: A Trailblazer in Multiple Industries
          </h3>
          <p style={{ fontSize: '13.5px', color: 'rgba(255,255,255,0.60)', lineHeight: 1.95 }}>
            {bio?.about_sliders?.[1]?.description || bio?.about_sliders?.[0]?.description || "Ghassan's professional career commenced in 2004 in Qatar, where he gained extensive experience across diverse industries. His roles included managing servers for prestigious accounts like Qatar Foundation and Q-Tel at HP, excelling in automotive sales at Al-Mannai, and serving as a Business Development Officer Acting Manager at IBQ."}
          </p>
        </div>
      </section>

      {/* FOLLOW GHASSAN — real social links from API */}
      <section style={{ background: '#07090e', padding: '60px 0' }}>
        <div style={{ maxWidth: '700px', margin: '0 auto', padding: '0 40px', textAlign: 'center' }}>
          <h2 style={{ fontSize: '22px', fontWeight: 900, color: '#fff', letterSpacing: '0.14em', marginBottom: '14px' }}>FOLLOW GHASSAN.</h2>
          <p style={{ fontSize: '13px', color: 'rgba(255,255,255,0.52)', lineHeight: 1.85, marginBottom: '28px' }}>
            Discover How Embracing The Strength Of Unity Can Elevate Us To Unprecedented Heights. Welcome To A Story Where The True Victory Lies In Our Shared Success.
          </p>
          <div style={{ display: 'flex', justifyContent: 'center', gap: '12px', flexWrap: 'wrap' }}>
            {socialLinks.length > 0 ? socialLinks.map(s => (
              <a key={s.id} href={s.link} target="_blank" rel="noopener noreferrer"
                style={{ width: '38px', height: '38px', borderRadius: '6px', background: 'rgba(255,255,255,0.07)', border: '1px solid rgba(255,255,255,0.14)', display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden' }}>
                {s.icon.endsWith('.svg') || s.icon.endsWith('.png') ? (
                  <img src={s.icon} alt="" style={{ width: '18px', height: '18px', objectFit: 'contain', filter: 'brightness(0) invert(1)' }} />
                ) : (
                  <span style={{ fontSize: '12px', color: '#fff', fontWeight: 700 }}>{s.link.includes('twitter') ? 'X' : s.link.includes('linkedin') ? 'in' : s.link.includes('instagram') ? 'IG' : s.link.includes('facebook') ? 'f' : '★'}</span>
                )}
              </a>
            )) : (
              [
                <svg key="x" width="16" height="16" viewBox="0 0 24 24" fill="white"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.744l7.73-8.835L1.254 2.25H8.08l4.259 5.629L18.244 2.25z"/></svg>,
                <svg key="li" width="16" height="16" viewBox="0 0 24 24" fill="white"><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"/><rect x="2" y="9" width="4" height="12"/><circle cx="4" cy="4" r="2"/></svg>,
                <svg key="ig" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2"><rect x="2" y="2" width="20" height="20" rx="5"/><circle cx="12" cy="12" r="5"/><circle cx="17.5" cy="6.5" r="1" fill="white" stroke="none"/></svg>,
                <svg key="fb" width="16" height="16" viewBox="0 0 24 24" fill="white"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/></svg>,
              ].map((icon, i) => (
                <a key={i} href="#" style={{ width: '38px', height: '38px', borderRadius: '6px', background: 'rgba(255,255,255,0.07)', border: '1px solid rgba(255,255,255,0.14)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{icon}</a>
              ))
            )}
          </div>
        </div>
      </section>

      {/* FROM HIS BLOG */}
      <section className="relative overflow-hidden" style={{ background: '#161920', padding: '64px 0' }}>
        <div className="absolute inset-0 pointer-events-none" style={{ backgroundImage: 'url(/arab-pattern-bg.jpg)', backgroundSize: 'cover', opacity: 0.07, zIndex: 0 }} />
        <div className="absolute inset-0 pointer-events-none" style={{ background: 'rgba(16,18,26,0.80)', zIndex: 0 }} />
        <div className="relative z-10" style={{ maxWidth: '1000px', margin: '0 auto', padding: '0 32px' }}>
          <h2 style={{ fontSize: '22px', fontWeight: 700, color: '#fff', textAlign: 'center', marginBottom: '10px' }}>From His Blog</h2>
          <p style={{ fontSize: '13px', color: 'rgba(255,255,255,0.48)', textAlign: 'center', lineHeight: 1.85, maxWidth: '520px', margin: '0 auto 40px' }}>
            Dive Into The Blog For The Latest Updates, Expert Opinions, And Detailed Information On Our Projects. Stay Updated With Content Relevant To You.
          </p>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '18px' }}>
            {(latestBlogs.length > 0 ? latestBlogs : [
              { id: '1', title: 'Fly High With Our Exclusive Travel Tips', image: '/blog-homs.jpg', date: '24/08/2024', category: 'Travel', likes: 23, comments: 5 },
              { id: '2', title: 'Fly High With Our Exclusive Travel Tips', image: '/blog-steve-jobs.jpg', date: '24/08/2024', category: 'Travel', likes: 23, comments: 5 },
              { id: '3', title: 'Fly High With Our Exclusive Travel Tips', image: '/investment-wealth.jpg', date: '24/08/2024', category: 'Travel', likes: 23, comments: 5 },
            ]).map((p: any) => (
              <BlogCard key={p.id} id={String(p.id)} title={p.title} image={p.image} date={p.created_at || p.date} category={p.category || ''} likes={p.likes_count ?? p.likes ?? 0} comments={p.comments_count ?? p.comments ?? 0} />
            ))}
          </div>
        </div>
      </section>
      <NewsletterSection />
    </>
  )
}
